<!-- @format -->

<clp-category-header-with-deals
	[categoryData]="categoryData"
	[homrContent]="data.content">
</clp-category-header-with-deals>
<shared-components-google-ad-manager
	*ngIf="clpGoogleAdManagerEnabled"
	[data]="GAMId"
	[breadcrumbData]="categoryData.breadCrumbDetails"
	[showSponsoredLabel]="true"
	[enableTooltipSurvey]="enableTooltipSurvey">
</shared-components-google-ad-manager>

<div
	class="row marketing-content-2"
	*ngIf="data && data.content && data.content['Spot 2']">
	<div
		class="col-12"
		[ngClass]="{
			'col-md-4': data.content['Spot 2'].length === 3,
			'col-md-6': data.content['Spot 2'].length === 2
		}"
		*ngFor="let attr of data.content['Spot 2']; trackBy: trackByFn">
		<clp-marketing-story
			[data]="attr"
			[spotNumber]="2 + index + ''"></clp-marketing-story>
	</div>
</div>

<div
	class="row marketing-content-3"
	*ngIf="data && data.content && data.content['Spot 3']">
	<div class="col-12">
		<clp-marketing-story
			[data]="data.content['Spot 3'][0]"
			[spotNumber]="data.content['Spot 2'].length + 2 + ''">
		</clp-marketing-story>
	</div>
</div>
